import NumberFormat from "react-number-format";
import Input from "./Input";

interface Props {
  value: string;
  onChange: (value) => void;
  [x: string]: any;
}

interface InputComponentProps {
  [x: string]: any;
}
const InputComponent = (props: InputComponentProps) => {
  return (
    <Input
      sx={{
        marginRight: "1",
        marginLeft: "1",
        display: "block",
        cursor: "pointer",
        borderRadius: "default",
        width: "96px",
        height: "48px",
        fontSize: 0,
        lineHeight: "48px",
        textAlign: "center",
        color: "labradorblack",
        border: "default",
        paddingLeft: 0,
        paddingRight: 0,
        boxShadow: "inputFocus",
        ":focus": {
          borderColor: "gray",
          outline: "none",
          boxShadow: "inputFocus",
          "~i": {
            opacity: 1
          }
        }
      }}
      {...props}
    ></Input>
  );
};
const InputInt = ({ value, onChange, ...rest }: Props) => {
  return (
    <NumberFormat
      value={value}
      displayType={"input"}
      thousandSeparator={true}
      customInput={InputComponent}
      onValueChange={onChange}
      allowNegative={false}
      decimalScale={0}
      {...rest}
    />
  );
};

export default InputInt;
